var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('TableApp', {
    ref: "tabela",
    attrs: {
      "titulo": "Clientes e contatos",
      "api-url": "/crm/contatos/lista",
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "toolbar-actions",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-dark font-weight-bolder font-size-sm",
          on: {
            "click": _vm.abrirModal
          }
        }, [_vm._v(" Novo contato ")])];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "crm-contato-modal",
      "title": "Novo contato",
      "ok-title": "Salvar",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "WhatsApp"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Telefone com DDD",
      "type": "tel"
    },
    model: {
      value: _vm.form.telefone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telefone", $$v);
      },
      expression: "form.telefone"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "E-mail"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Observações"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.form.observacoes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacoes", $$v);
      },
      expression: "form.observacoes"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };